import type { ProductSummary as ProductSummaryType } from '@/lib/api/amazon-listing'
import {
  ProductIdentityCard,
  MarketLandscapeCard,
  CustomerVoiceCard,
  UseCasesCard,
  RegionalInfoCard,
  KeyFactsCard,
  PotentialCard,
} from './ProductSummaryParts'

interface ProductSummaryProps {
  data: ProductSummaryType
}

export function ProductSummary({ data }: ProductSummaryProps) {
  if (!data) return null

  return (
    <div className="space-y-4">
      {data.product_identity && <ProductIdentityCard data={data.product_identity} />}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {data.market_landscape && <MarketLandscapeCard data={data.market_landscape} />}
        {data.customer_voice && <CustomerVoiceCard data={data.customer_voice} />}
      </div>
      {data.use_cases && <UseCasesCard data={data.use_cases} />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {data.regional_info && <RegionalInfoCard data={data.regional_info} />}
        {data.key_facts && <KeyFactsCard data={data.key_facts} />}
      </div>
      {data.potential && <PotentialCard data={data.potential} />}
    </div>
  )
}
